export function formatFileSize(size: number | null): string {
  if (size === null || size === undefined) {
    return 'Unknown size'
  }

  const i = Math.floor(Math.log(size) / Math.log(1024))
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  const fileSize = size / Math.pow(1024, i)

  return `${fileSize.toFixed(2)} ${sizes[i]}`
}
